<script>
    import { scaleLinear, scaleTime, scaleDiverging, timeYear, line, area, timeParse, extent, interpolateRdYlBu } from 'd3';
    import YAxis from './yAxisH.svelte';
    import XAxis from './xAxisH.svelte';
    let { data, width, highlights } = $props();

    const dates = data.map(d => timeParse('%Y-%m-%d')(d.dt));

    const height = 250;

    const margin = {top: 25, left: 50, bottom: 25, right: 10};

    let chartwidth = $derived(width - margin.left - margin.right);
    const chartheight = height - margin.top - margin.bottom;

    const yScale = scaleLinear().domain([-2.5, 2.5]).range([chartheight, 0]);
    const yTicks = [-2.5, -2,-1.5, -1,  -0.5, 0, 0.5, 1, 1.5, 2, 2.5];
    const yLabels = [-2, -1, -0.5, 0, 0.5, 1, 2];

    const colorScale = scaleDiverging([2.5, 0, -2.5], interpolateRdYlBu);

    // Sample the diverging scale across the y-domain (oni 3 -> -3) for a vertical gradient
    const gradientStops = Array.from({ length: 25 }, (_, i) => 3 - (i / 24) * 6);

    const xDomain = extent(dates);
    const xTicks = timeYear.every(10).range(...xDomain);

    const xScale = $derived(
        chartwidth && xDomain ? 
        scaleTime()
            .range([0, chartwidth])
            .domain(xDomain) :
        null
    )

    const lineGen = $derived(
        xScale ? 
        line()
            .x(d => xScale(timeParse('%Y-%m-%d')(d.dt)))
            .y(d => yScale(d.oni)) :
        null
    )

    // Area between the line and the +0.5 baseline (clipped to the El Niño band)
    const ninoArea = $derived(
        xScale ?
        area()
            .x(d => xScale(timeParse('%Y-%m-%d')(d.dt)))
            .y0(yScale(0.5))
            .y1(d => yScale(d.oni)) :
        null
    )

    // Area between the line and the -0.5 baseline (clipped to the La Niña band)
    const ninaArea = $derived(
        xScale ?
        area()
            .x(d => xScale(timeParse('%Y-%m-%d')(d.dt)))
            .y0(yScale(-0.5))
            .y1(d => yScale(d.oni)) :
        null
    )
</script>

<svg {width} {height}>
    <defs>
        <!-- Vertical gradient: color maps to oni value (height), anchored to yScale -->
        <linearGradient
            id="nino-gradient"
            gradientUnits="userSpaceOnUse"
            x1="0" y1={yScale(3)} x2="0" y2={yScale(-3)}
        >
            {#each gradientStops as oni}
                <stop stop-color={colorScale(oni)} offset="{(3 - oni) / 6 * 100}%" />
            {/each}
        </linearGradient>
    </defs>
    
    <YAxis {yScale} {yTicks} {yLabels} {width} {margin}/>
    
    <g transform="translate({margin.left}, {margin.top})">
        <clipPath id="nino">
            <rect x=0 y=0 width={chartwidth} height={yScale(0.5)}></rect>

        </clipPath>
        <clipPath id="nina">
            <rect x=0 y={yScale(-0.5)} width={chartwidth} height={chartheight - yScale(-0.5)}></rect>
        </clipPath>
        <XAxis {xScale} {xTicks} {chartheight} {margin} />
        {#if lineGen}
            <!-- Event area fills, clipped to the ±0.5 bands -->
            <path d={ninoArea(data)} fill="url(#nino-gradient)" opacity=0.3 clip-path="url(#nino)"></path>
            <path d={ninaArea(data)} fill="url(#nino-gradient)" opacity=0.3 clip-path="url(#nina)"></path>

            <!-- Base line -->
            <path d={lineGen(data)} fill="none" stroke="#666" stroke-width=0.5></path>

            <!-- Highlighted line, clipped to the ±0.5 bands -->
            <path d={lineGen(data)} fill="none" stroke="url(#nino-gradient)" stroke-width=2 clip-path="url(#nino)"></path>
            <path d={lineGen(data)} fill="none" stroke="url(#nino-gradient)" stroke-width=2 clip-path="url(#nina)"></path>
        {/if}
        {#each highlights as h}
            {@const datum = data.find(d => d.dt === h.dt)}
            {@const cx = xScale(timeParse('%Y-%m-%d')(h.dt))}
            {@const cy = yScale(datum.oni)}
            <text class="highlight-text" x={cx} y={cy-15} fill="{colorScale(3)}">{h.label}</text>
            <circle {cx} {cy} r="10" fill="none" class="highlight-circle" stroke="{colorScale(3)}"></circle>
        {/each}
    </g>
</svg>

<style lang='scss'>
    .highlight-circle {
        // stroke: $gray8;
    }
    .highlight-text {
        text-anchor: middle;
        font-weight:700;
        font-size: 12px;
    }
</style>